module.exports = __webpack_public_path__ + "static/sass-74c362907475d0d7f0d59d0fb662135c.png";